interface Props {
  label: string;
  value: string;
}
/**
 * Converts the given enum to a map of the keys to the values.
 * @param enumeration The enum to convert to a map.
 */
export const convertEnumToMap = (enumeration: any): Map<string, string | number> => {
  const map = new Map<string, string | number>()
  for (const key in enumeration) {
    // TypeScript does not allow enum keys to be numeric
    if (!isNaN(Number(key))) continue

    const val = enumeration[key] as string | number

    // TypeScript does not allow enum value to be null or undefined
    if (val !== undefined && val !== null) map.set(key, val)
  }

  return map
}

/**
 * Array of each entry
 * @param enumeration The enum to convert to an entries.
 */
export const convertEnumToEntries = (enumeration: any) => {
  return Array.from(convertEnumToMap(enumeration).entries())
}

/**
 * An array of keys
 * @param enumeration The enum to convert to a keys
 */
export const convertEnumToKeys = (enumeration: any) => {
  return Array.from(convertEnumToMap(enumeration).keys())
}

/**
 * An array of values
 * @param enumeration The enum to convert to a values
 */
export const convertEnumToValues = (enumeration: any) => {
  return Array.from(convertEnumToMap(enumeration).values())
}

/**
 * An Array of Object Array
 * @param enumeration
 * @param props
 */
export const convertEnumToArray = (enumeration: any, props: Props = { label: 'label', value: 'value' }) => {
  return convertEnumToEntries(enumeration)
    .map(m => {
      const item: anyObj = {}
      item[props.label] = m[0]
      item[props.value] = m[1]
      return item
    })
}
